'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleUGCForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcon = require('@bibliocommons/base-icon');

var _baseIcon2 = _interopRequireDefault(_baseIcon);

var _changeCase = require('change-case');

var _baseIcons = require('@bibliocommons/base-icons');

var Icons = _interopRequireWildcard(_baseIcons);

var _baseAccessibilityTextArea = require('@bibliocommons/base-accessibility-text-area');

var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);

require('../styles/SimpleUGCForm.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleUGCForm = exports.SimpleUGCForm = function (_BcReactComponent) {
  _inherits(SimpleUGCForm, _BcReactComponent);

  function SimpleUGCForm(props) {
    _classCallCheck(this, SimpleUGCForm);

    var _this = _possibleConstructorReturn(this, (SimpleUGCForm.__proto__ || Object.getPrototypeOf(SimpleUGCForm)).call(this, props));

    _this.state = {
      expanded: false,
      isEmpty: _this.props.body.length < 1
    };

    _this.bindAll('renderCancelButton', 'renderDeleteButton', 'handleChange', 'handleFocus', 'handleBlur');
    return _this;
  }

  _createClass(SimpleUGCForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'handleChange',
    value: function handleChange(value) {
      this.setState({
        isEmpty: value.length < 1
      });
      this.props.handleChange(value);
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      this.setState({
        expanded: true
      });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.setState({
        expanded: false
      });
    }
  }, {
    key: 'renderCancelButton',
    value: function renderCancelButton() {
      var _props = this.props,
          handleCancel = _props.handleCancel,
          submitting = _props.submitting;

      return _react2.default.createElement(
        'button',
        { type: 'button', onClick: handleCancel, className: 'btn btn-link pull-right', disabled: submitting },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel_button' })
      );
    }
  }, {
    key: 'renderDeleteButton',
    value: function renderDeleteButton() {
      var _props2 = this.props,
          handleDelete = _props2.handleDelete,
          submitting = _props2.submitting;


      return _react2.default.createElement(
        'button',
        { type: 'button', className: 'btn btn-link', onClick: handleDelete, disabled: submitting },
        _react2.default.createElement(_baseIcon2.default, { icon: 'icon-trash' }),
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'delete_button' })
      );
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader(labelId) {
      var _props3 = this.props,
          formHeadingText = _props3.formHeadingText,
          ugcType = _props3.ugcType;

      if (!formHeadingText) return null;
      var UGCIcon = Icons[(0, _changeCase.pascal)(ugcType)];

      return _react2.default.createElement(
        'h3',
        { id: labelId },
        _react2.default.createElement(UGCIcon, null),
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: formHeadingText })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          characterLimit = _props4.characterLimit,
          submitting = _props4.submitting,
          body = _props4.body,
          handleSubmit = _props4.handleSubmit,
          placeholderText = _props4.placeholderText,
          submitButtonText = _props4.submitButtonText,
          setFocus = _props4.setFocus,
          errorKey = _props4.errorKey,
          fieldErrors = _props4.fieldErrors,
          intl = _props4.intl;
      var _state = this.state,
          isEmpty = _state.isEmpty,
          expanded = _state.expanded;


      var labelId = _lodash2.default.uniqueId('simpleUGCForm_');
      var formClass = expanded || !isEmpty ? 'active' : '';
      var disableSubmit = submitting || isEmpty;
      var buttonClass = expanded || !isEmpty ? 'btn btn-primary' : 'btn btn-default';

      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit, className: 'cp-simple-ugc-form ' + formClass },
        this.renderHeader(labelId),
        _react2.default.createElement(_baseAccessibilityTextArea2.default, {
          errorKey: errorKey,
          fieldErrors: fieldErrors,
          className: 'input-lg',
          placeholder: intl.formatMessage({ id: placeholderText }),
          maxLength: characterLimit,
          value: body,
          setFocus: setFocus,
          labelledById: labelId,
          disabled: submitting,
          handleFocus: this.handleFocus,
          handleBlur: this.handleBlur,
          handleChange: this.handleChange }),
        _react2.default.createElement(
          'div',
          { className: 'ugc-actions' },
          this.props.handleDelete ? this.renderDeleteButton() : null,
          _react2.default.createElement('input', { type: 'submit', value: intl.formatMessage({ id: submitButtonText }), className: 'btn ' + buttonClass + ' pull-right', disabled: disableSubmit }),
          this.props.handleCancel ? this.renderCancelButton() : null
        )
      );
    }
  }]);

  return SimpleUGCForm;
}(_baseBcReactComponent2.default);

SimpleUGCForm.propTypes = {
  errorKey: _react.PropTypes.string.isRequired,
  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  })),
  formHeadingText: _react.PropTypes.string,
  submitButtonText: _react.PropTypes.string.isRequired,
  placeholderText: _react.PropTypes.string.isRequired,
  submitting: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  body: _react.PropTypes.string,
  setFocus: _react.PropTypes.bool,
  handleChange: _react.PropTypes.func.isRequired,
  handleCancel: _react.PropTypes.func,
  handleLogin: _react.PropTypes.func,
  handleDelete: _react.PropTypes.func.isRequired,
  intl: _reactIntl.intlShape,
  characterLimit: _react.PropTypes.number,
  ugcType: _react.PropTypes.string.isRequired
};

SimpleUGCForm.defaultProps = {
  user: { loggedIn: false },
  submitting: false,
  body: '',
  formHeadingText: false,
  handleCancel: false,
  handleLogin: false,
  handleDelete: false
};
exports.default = (0, _reactIntl.injectIntl)(SimpleUGCForm);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/simple-ugc-form/components/SimpleUGCForm.js
// module id = 1537
// module chunks = 1